var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmerald(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_77591)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_77591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2114 8.47461H9.04688V17.1134L9.51213 18.1741C9.58557 18.1741 9.65901 18.1384 9.70226 18.067L15.0191 9.28932C15.0401 9.25459 15.0512 9.21475 15.0512 9.17415L13.2114 8.47461Z",
    fill: "#0ED290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1139 8.38477L9.0484 8.52739L8.88281 11.6957L9.50114 14.5272C9.57458 14.5272 9.64802 14.4915 9.69127 14.4201L12.799 9.28951C12.82 9.25477 12.8311 9.21494 12.831 9.17434L11.1139 8.38477Z",
    fill: "#05E39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3177 0.280984L4.00092 9.05866C3.97992 9.09341 3.9688 9.13323 3.96875 9.17383H6.178L9.50786 3.8209V0.173828C9.43432 0.173828 9.36081 0.209266 9.3177 0.280984Z",
    fill: "#CFFCE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.178 9.17383H3.96875C3.96875 9.21366 3.97954 9.25349 4.00092 9.289L9.3177 18.0667C9.36081 18.1384 9.43432 18.1738 9.50783 18.1738V14.5268L6.178 9.17383Z",
    fill: "#00F2A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70261 18.0667L15.0194 9.28896C15.0405 9.25423 15.0516 9.2144 15.0516 9.17379C15.0516 9.13318 15.0404 9.09335 15.0194 9.05862L9.70261 0.280949C9.65933 0.209547 9.58593 0.173828 9.51248 0.173828L9.38986 0.706269L9.51248 1.46185L14.114 9.05862C14.135 9.09335 14.1461 9.13318 14.1461 9.17379C14.1461 9.2144 14.135 9.25423 14.114 9.28896L9.51248 16.8857L9.32812 17.6224L9.51248 18.1738C9.58593 18.1738 9.65937 18.1381 9.70261 18.0667Z",
    fill: "#07B27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05469 17.6322L9.31727 18.0657C9.36051 18.1371 9.43399 18.1728 9.50743 18.1728V16.8848L9.05469 17.6322Z",
    fill: "#0ED290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31727 0.280984L9.05469 0.714461L9.50743 1.46188V0.173863C9.43399 0.173863 9.36055 0.209547 9.31727 0.280984ZM15.0143 9.05866L9.69755 0.280984C9.65445 0.209266 9.58094 0.173828 9.50743 0.173828V3.8209L12.8373 9.17383H15.0465C15.0465 9.13323 15.0353 9.0934 15.0143 9.05866Z",
    fill: "#00F2A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50951 3.82227L9.86107 7.9468L9.50951 9.17519L7.90424 9.52675L6.17969 9.17519C6.17969 9.13536 6.19023 9.09549 6.21161 9.06002L9.31939 3.92946C9.36245 3.85774 9.43596 3.82227 9.50951 3.82227Z",
    fill: "#6CF5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8394 9.17519H9.50951V3.82227C9.58302 3.82227 9.65657 3.85774 9.69964 3.92942L12.8074 9.06002C12.8283 9.09479 12.8394 9.13461 12.8394 9.17519ZM9.50951 9.17519V14.5281C9.436 14.5281 9.36245 14.4927 9.31939 14.421L6.21161 9.29036C6.19068 9.25559 6.17965 9.21577 6.17969 9.17519H9.50951Z",
    fill: "#9CF8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69794 0.280984C9.65484 0.209266 9.58132 0.173828 9.50781 0.173828V1.46185L14.1093 9.05866C14.1304 9.09338 14.1415 9.13322 14.1415 9.17383H15.0469C15.0468 9.13323 15.0357 9.09341 15.0147 9.05866L9.69794 0.280984Z",
    fill: "#0ED290"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_77591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.173828)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_77591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.173828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmerald);
export default __webpack_public_path__ + "static/media/emerald.44aa2274525afd73d7bfd79117d37c7a.svg";
export { ForwardRef as ReactComponent };